<template>
    <!-- TODO: Handle more complex icons -->
    <SparkListItem
        :start-item="content.start?.type"
        :start-icon="content.start?.type === 'icon' && content.start.icon_data?.icon ? `ph:${content.start.icon_data.icon}` : null"
        :start-date="['date', 'time'].includes(content.start?.type) ? content.start.date : null"
        :end-item="content.end?.type"
        :end-image="content.end?.type === 'image' ? content.end.image : null"
        :end-icon="content.end?.type === 'icon' && content.end.icon_data?.icon ? `ph:${content.end.icon_data.icon}` : null"
        :subtext="content.subtext"
        :more-subtext="content.more_subtext"
        :class="{ 'cursor-pointer': config.link }"
        :bottom-divider="content.bottom_divider"
        @click="onClick"
    >
        <template
            v-if="content.start?.type === 'custom-icon'"
            #start-item
        >
            <UIIcon
                :icon="content.start.icon_data"
                :size="24"
                class="shrink-0"
            />
        </template>
        <template
            v-if="content.feature_top?.type === 'image'"
            #feature-top
        >
            <UIImage
                :src="content.feature_top.image"
                class="mb-4"
            />
        </template>
        <template #eyebrow>
            <template v-if="content.eyebrow?.type === 'icon-text'">
                <SparkListItemEyebrowIconText
                    :icon="content.eyebrow.icon_data"
                    :html="content.eyebrow.title"
                />
            </template>
            <template v-if="content.eyebrow?.type === 'badges'">
                <SparkListItemEyebrowBadges :badges="content.eyebrow.badges" />
            </template>
        </template>
        <template
            v-if="content.title"
            #title
        >
            <UIHtml
                :html="content.title"
                class="prose leading-5 text-[length:inherit] text-inherit"
                style="overflow-wrap: anywhere;"
            />
        </template>
        <template
            v-if="content.description"
            #description
        >
            <div
                class="content-sm-ux-regular mb"
                :class="lineClampClass"
            >
                <UIHtml
                    :html="content.description"
                    class="prose leading-5 text-[length:inherit] text-inherit"
                    style="overflow-wrap: anywhere;"
                />
            </div>
        </template>
        <template
            v-if="content.end?.type === 'custom-icon' || $slots['end-item']"
            #end-item
        >
            <slot name="end-item" />
            <template v-if="content.end?.type === 'custom-icon'">
                <UIIcon
                    :icon="content.end.icon_data"
                    :size="24"
                    class="shrink-0"
                />
            </template>
        </template>
    </SparkListItem>
</template>
<script setup>
    import { useRouter } from 'vue-router'
    import SparkListItem from '@/components/ui/SparkListItem.vue'

    const props = defineProps({
        config: Object,
    })

    const router = useRouter()
    const moduleHelpers = useModuleHelpers()

    const clicking = ref(false)

    const meta = computed(() => props.config.meta)
    const content = computed(() => props.config.data)

    const lineClampClass = computed(() => {
        switch (content.value.lineClamp) {
            case 1:
                return 'line-clamp-1'
            case 2:
                return 'line-clamp-2'
            case 3:
                return 'line-clamp-3'
            case 4:
                return 'line-clamp-4'
            case 5:
                return 'line-clamp-5'
            case 6:
                return 'line-clamp-6'
            default:
                return ''
        }
    })

    const onClick = () => {
        if (clicking.value) {
            return
        }

        clicking.value = true
        moduleHelpers.handleClick(router, props.config, get(meta, ['value', 'id']))
            .catch((e) => {
                console.log('Failed to open link', e)
            })
            .finally(() => {
                clicking.value = false
            })
    }
</script>
